import { Flex, MenuContent, Menu, MenuTrigger, MenuItem, Text } from '@cad-arc';
import { CommandIconButton, ShortcutCommand } from './styled';
import CommandIcon from '../../esri/images/command-icon/command_icon.svg';
import { SHORTCUTS } from '../constants';
import { Tooltip } from '~/common/components/tooltip';

export function EsriMapShortcuts() {
    return (
        <Menu>
            <MenuTrigger asChild>
                <CommandIconButton>
                    <Tooltip overlay="Map Shortcuts" mouseEnterDelay={0.5}>
                        <img src={CommandIcon} alt="icon" />
                    </Tooltip>
                </CommandIconButton>
            </MenuTrigger>
            <MenuContent align="end" side="top" style={{ minWidth: '16rem' }}>
                {SHORTCUTS.map((shortcut) => (
                    <MenuItem key={shortcut.command}>
                        <Flex alignItems="center" justifyContent="space-between">
                            <Text>{shortcut.text}</Text>
                            <ShortcutCommand alignItems="center" justifyContent="center">
                                {shortcut.command}
                            </ShortcutCommand>
                        </Flex>
                    </MenuItem>
                ))}
            </MenuContent>
        </Menu>
    );
}
